export const KEYS = {
  OFFSET_BOTTOM_NEXT_PAGE: 50,
  DEBOUNCE_TIMEOUT: 500,
  SCROLL_THROTTLE_TIMEOUT: 100,
};

export default KEYS;
